import React from 'react'
import { useSelector } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import { selectAdditionalProcedureList, selectDispatchRegionList, selectMeasurementUnitList, selectPackageCodesList, selectPreviousProcedureList } from '../selectors'
import { MerchForm1, MerchForm2, MerchForm3, MerchForm4 } from './MerchandiseForms'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'

export const MerchandiseForm = React.memo(({ dataSource, countryList, packageDataSource, packages,invoiceId ,copyDocument=null,validateLineItem,disabled, isDisabled,...rest }) => {
  const proceduresList = useSelector(selectPreviousProcedureList)
  const addProceduresList = useSelector(selectAdditionalProcedureList)
  const regionDispatchList = useSelector(selectDispatchRegionList)
  const packageTypeList = useSelector(selectPackageCodesList)
  const uomList = useSelector(selectMeasurementUnitList)
  
const { currency, exchangeRate } =
    useSelector((state) => state.invoiceReducer.invoice.invoiceMap[invoiceId]?.invoiceHeader) || {}
      const { version, isImportShipment ,serviceType} = useCurrentShipmentType()
      const isDMS = version === 'DMS'
  return (
    <Grid className='responsiveGridCss' style={{ marginBottom: '1rem' }}>
      <Grid.Row>
        <MerchForm1
          dataSource={dataSource}
          packages={packages}
          isDMS={isDMS}
          isImportShipment={isImportShipment}
          packageDataSource={packageDataSource}
          {...rest}
          packageTypeList={packageTypeList}
          validateLineItem={validateLineItem}
        />
        <MerchForm2
          dataSource={dataSource}
          isDMS={isDMS}
          version={version}
          serviceType={serviceType}
          copyDocument={copyDocument}
          isImportShipment={isImportShipment}
          {...rest}
          countryList={countryList}
          regionDispatchList={regionDispatchList}
          validateLineItem={validateLineItem}
        />
        <MerchForm3
          isDMS={isDMS}	
          isImportShipment={isImportShipment}
          dataSource={dataSource}
          {...rest}
          proceduresList={proceduresList}
          addProceduresList={addProceduresList}
          countryList={countryList}
          validateLineItem={validateLineItem}
        />
        <MerchForm4
          isDMS={isDMS}	
          isImportShipment={isImportShipment}
          dataSource={dataSource}
          disabled={disabled}
          {...rest}
          uomList={uomList}
          currency={currency}
          exchangeRate={exchangeRate}
          validateLineItem={validateLineItem}
          isDisabled={isDisabled}
        />
      </Grid.Row>
    </Grid>
  )
})

